import React from 'react';
import Box from '../Box/Box';

const Block = ({ ...rest }) => <Box {...rest} as="div" name="Block" />;

Block.propTypes = {};

export default Block;
